export const LATEST_ORDERS_ACTION_TYPES = {
  FETCH_LATEST_ORDERS_REQUEST: "FETCH_LATEST_ORDERS_REQUEST",
  FETCH_LATEST_ORDERS_SUCCESS: "FETCH_LATEST_ORDERS_SUCCESS",
  FETCH_LATEST_ORDERS_FAILURE: "FETCH_LATEST_ORDERS_FAILURE"
};
